// extracted by mini-css-extract-plugin
module.exports = {"input":"FormText_input__XPCQO","togglePassword":"FormText_togglePassword__XoK6N","smallRect":"FormText_smallRect__qXYgC","disabled":"FormText_disabled__lE7Cu"};